import { CheckIcon } from '@/components/ui/icons'
import { Separator } from '@/components/ui/separator'
import type { RemapExperienceVetting } from '@/features/experience-vetting/types.ts'
import {
	OpsVettingCardGrid,
	OpsVettingDisabledContainer,
	OpsVettingParagraph,
	OpsVettingSectionTitle,
	OpsVettingSectionWrapper
} from '@/features/ops-vetting/components/ops-vetting-atoms'
import { useTranslation } from '@/translations/i18n.tsx'
import { ExperienceVettingCriteriaItineraryCard } from './experience-vetting-criteria-itinerary-card'

export const ExperienceVettingCriteriaItinerary = ({
	experience,
	isReadOnly
}: {
	experience: RemapExperienceVetting
	isReadOnly: boolean
}) => {
	const { t } = useTranslation()

	const isDeclined = experience.expertise.status === 'declined'

	const itineraryNotReviewed = experience.itineraries.filter(
		(itinerary) => itinerary.status === null
	)

	return (
		<OpsVettingSectionWrapper direction={'column'} fullWidth gap={6}>
			<div className='flex w-full items-center justify-between'>
				<OpsVettingSectionTitle>
					{t('vetting:criteria.experience.itinerary.title')}
				</OpsVettingSectionTitle>
				<OpsVettingParagraph>
					{itineraryNotReviewed.length > 0 ? (
						t('vetting:criteria.experience.itinerary.x_remaining', {
							count: itineraryNotReviewed.length
						})
					) : (
						<span className='flex gap-1'>
							<CheckIcon className='fill-success-600' size={20} />
							{t('vetting:criteria.commons.reviewed')}
						</span>
					)}
				</OpsVettingParagraph>
			</div>
			<Separator orientation='horizontal' />
			<OpsVettingDisabledContainer $isDisabled={isDeclined}>
				<OpsVettingCardGrid>
					{experience.itineraries.map((itinerary, index) => (
						<ExperienceVettingCriteriaItineraryCard
							galleryId={experience.gallery.id}
							index={index}
							isReadOnly={isReadOnly}
							itinerary={itinerary}
							key={itinerary.id}
						/>
					))}
				</OpsVettingCardGrid>
			</OpsVettingDisabledContainer>
		</OpsVettingSectionWrapper>
	)
}
